import { Injectable } from '@angular/core';

import { Accordion } from './accordion.types';

@Injectable()
export class AccordionService {
  private accordions: Accordion[] = [];

  public register(accordion: Accordion): void {
    this.accordions.push(accordion);
  }

  public unregister(accordion: Accordion): void {
    this.accordions = this.accordions.filter(a => a !== accordion);
  }

  public toggle(current: Accordion): void {
    this.accordions.forEach(accordion => {
      if (accordion !== current) {
        accordion.close();
      } else {
        accordion.toggleOpen();
      }
    });
  }
}
